<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div class="col-md-12 px-2 my-4">
        <v-card-title class="text-center justify-center pa-2">
          {{ title }}
        </v-card-title>
        <v-card-subtitle class="ma-0 pa-2 text-center">
          {{ description }}
        </v-card-subtitle>

        <v-row dense>
          <v-col v-for="(item, index) in info" :key="index" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-if="item.format !== 'select'"
                :key="index"
                v-model="item.value"
                :error-messages="
                  item.type !== 'optional' && !item.value
                    ? $t('required_field_error', { fieldName: item.persian })
                    : ''
                "
                :label="item.persian"
                :type="item.format"
                clear-icon="mdi-close-circle-outline"
                clearable
                class="contentinfo"
                dense
                flat
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-item-value`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="item.persian"
              />
            </div>
            <div class="rowinfo">
              <v-autocomplete
                v-if="item.format === 'select'"
                :items="item?.extra?.options"
                :label="item?.extra?.label"
                dense
                class="contentinfo"
                flat
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-${item?.extra?.label}`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="item?.extra?.label"
              />
            </div>
          </v-col>
          <v-col
            v-if="Object.keys(value).length > 0"
            class="mx-auto text-center"
            cols="12"
          >
            <div class="rowinfo">
              <v-btn
                :loading="loading"
                class="col-8 mx-auto text-center text-white contentinfo"
                color="indigo"
                @click="submitForm"
              >
                {{ $t("submit_request_button") }}
              </v-btn>
              <help-info
                :element-name="`${serviceName}-${componentName}-submitForm`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('submit_request_button')"
              />
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
export default {
  name: "formsUi",
  props: {
    value: {
      default: {
        consultation: {},
      },
    },
    title: String,
    description: String,
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "formsui",
      loading: false,
    };
  },
  computed: {
    info() {
      return Object.values(this.value).filter(
        (item) => item.is_active === true
      );
    },
  },
  watch: {
    value: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
  },
  methods: {
    submitForm() {
      this.loading = true;
      this.$toast.success(this.$t("request_submitted_success"));
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
